import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './store/store';
import { ClerkProvider } from '@clerk/clerk-react';
import ClerkAxiosInterceptor from './components/ClerkAxiosInterceptor';
// Triggering dev server recompile


const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  console.warn("⚠️ REACT_APP_CLERK_PUBLISHABLE_KEY is missing from .env. Please configure it to enable authentication via API.");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    {PUBLISHABLE_KEY ? (
      <ClerkProvider publishableKey={PUBLISHABLE_KEY}>
        <Provider store={store}>
          <ClerkAxiosInterceptor>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </ClerkAxiosInterceptor>
        </Provider>
      </ClerkProvider>
    ) : (
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
